import { useNavigation } from '../../../hooks/useNavigation';

// Define the type for the row object that handleNavigate expects
interface TaskNavigationRow {
    object_type:
    | "recurring_task"
    | "stage_gate"
    | "checklist"
    | "activity"
    | "risk"
    | "queries"
    | "meeting"
    | "material_request"
    | "resource_request"
    | "artefact";
    project_id: number | null;
    programme_id: number | null;
    portfolio_id: number | null;
    object_id: number;
    project_title: string;
    task_id?: number;
}

export const useTaskNavigation = () => {
    const { goToRecurringTasks, goToSchedulePlanning, goToStageGates, goToRiskDashboard, goToQueries, goToMeetingDetails, goToMaterialRequestDetails, goToResourceRequestDetails, goToProjectArtefacts } = useNavigation();

    const handleNavigate = (row: TaskNavigationRow, isContractorPerson?: boolean, onOpenContractorDrawer?: (objectType: string, objectId: number, projectId?: number | null,  taskId?: number | null) => void) => {
        // If contractor person, open drawer locally instead of navigating
        if (isContractorPerson && onOpenContractorDrawer) {
            onOpenContractorDrawer(row.object_type, row.object_id, row.project_id, row.task_id);
            return;
        }
        switch (row.object_type) {
            case "recurring_task":
                if (row.project_id) {
                    goToRecurringTasks({
                        projectId: row.project_id,
                        projectName: row.project_title,
                    });
                }
                break;

            case "stage_gate":
            case "activity":
                if (row.project_id) {
                    goToSchedulePlanning({
                        projectId: row.project_id,
                        projectName: row.project_title,
                        objectId: row.object_id,
                        type: row.object_type === "stage_gate" ? "stageGate" : "activity",
                    });
                }
                break;

            case "checklist":
                if (row.project_id) {
                    goToStageGates({
                        projectId: row.project_id,
                        projectName: row.project_title,
                        objectId: row.object_id,
                    });
                }
                break;

            case "risk":
                goToRiskDashboard({ id: String(row.object_id) });
                break;

            case "queries":
                goToQueries(row.object_id);
                break;

            case "meeting":
                goToMeetingDetails(row.object_id);
                break;

            case "material_request":
                goToMaterialRequestDetails({
                    projectId: String(row.project_id), 
                    projectName: row.project_title, 
                    requestId: String(row.object_id)
                });
                break;

            case "resource_request":
                goToResourceRequestDetails({
                    projectId: String(row.project_id), 
                    projectName: row.project_title, 
                    requestId: String(row.object_id)
                });
                break;
            case "artefact":
                if(row.project_id) {
                    goToProjectArtefacts({
                        projectId: row.project_id,
                        projectName: row.project_title,
                        artefactId: String(row.object_id)
                })
                };
                break;

            default:
                // Potentially log an error or handle unknown object_type
                console.warn(`Unhandled object_type for navigation: ${row.object_type}`);
                break;
        }
    };

    return { handleNavigate };
};